// operator.ts — derive the operator slug from the branded-door hostname.
// A client arriving at d-14.sloelabs.com is coming through operator "d-14".
// The bare Studio host (sloelabs.com / www / studio / vercel previews / localhost)
// is a DIRECT Sloe Labs customer → null. The server stamps whatever we return
// onto operating_systems.operator_id at provision time.
//
// NOTE: this does NOT validate that the slug is a real/approved operator — that
// check arrives later with the operators config table + approval flow. For now
// we faithfully capture the leading subdomain label of a known root.

const KNOWN_ROOTS = ["sloelabs.com"];
const RESERVED_LABELS = new Set(["studio", "www", "tenant", "app", "dashboard", "downloads"]);

export function operatorSlugFromHostname(hostname: string = window.location.hostname): string | null {
  if (!hostname) return null;
  const host = hostname.toLowerCase().trim();

  // Never treat preview/local hosts as operator doors.
  if (host.endsWith("vercel.app")) return null;
  if (host === "localhost" || host.endsWith(".localhost")) return null;

  const root = KNOWN_ROOTS.find((r) => host === r || host.endsWith("." + r));
  if (!root) return null;            // unknown root → not an operator door
  if (host === root) return null;    // apex (sloelabs.com) → direct customer

  // Strip the root, take the leading label. d-14.sloelabs.com → "d-14".
  const prefix = host.slice(0, host.length - root.length - 1); // remove ".sloelabs.com"
  const label = prefix.split(".")[0];
  if (!label) return null;
  if (RESERVED_LABELS.has(label)) return null;

  // sanitize: lowercase slug, trim, cap length (mirrors server-side cap of 120)
  const slug = label.replace(/[^a-z0-9-]/g, "").slice(0, 120);
  return slug || null;
}
